import { Flex } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const IncomeAndExpenseWrapper = styled(Flex)`
  width: 100%;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 24px;
`
